import React from "react";
import "./entermessagebox.scss";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { createGeneralChat } from "../../../store/slices/projectSlice";
import { useLocation, useParams } from "react-router-dom";

export default function Entermessagebox(props) {
  const {
    setChatWithBot,
    tempUserData,
    loading,
    setLoading,
    scrollToBottom,
    isKnowledgeChat,
  } = props;
  const { focusedProject, selectedProject } = useSelector((state) => state.project);
  const { user } = useSelector((state) => state.auth);
  const [createChat, setCreateChat] = useState({ question: "" });

  const { id } = useParams();
  const { pathname } = useLocation();
  const { route } = useParams();

  const dispatch = useDispatch();

  let baseColor = selectedProject?.base_color || focusedProject?.base_color || "#008000";
  // Fallback for gradient: extract first color or use green
  if (baseColor?.includes("gradient")) {
    const match = baseColor.match(/#[0-9a-fA-F]{6}|rgba?\([^)]+\)/);
    baseColor = match ? match[0] : "#008000";
  }

  const validForm = () => {
    let Fromvlid = true;
    let errors = {};
    if (!createChat.question?.trim()) {
      Fromvlid = false;
      errors["question"] = "Question is required*";
    }

    return Fromvlid;
  };

  const handleCreateChat = (e) => {
    e.preventDefault();
    if (!validForm()) return;
    setLoading(true);
    setChatWithBot((prev) => [...prev, createChat?.question]);
    let isChat =
      pathname.includes("generalchat") || pathname.includes("/chat/");
    // Generate a stable admin-preview session ID if none available
    const adminPreviewSessionId =
      localStorage.getItem("admin_preview_session_id") ||
      (() => {
        const id = `admin-preview-${Date.now()}`;
        localStorage.setItem("admin_preview_session_id", id);
        return id;
      })();

    const body = {
      api_key: isChat ? id : focusedProject?.api_key,
      session_id: isChat ? (tempUserData || adminPreviewSessionId) : (user?.session_id || adminPreviewSessionId),
      question: createChat?.question,
      // Use isKnowledgeChat to determine route on settings page
      // Otherwise use pathname-based logic for public chat pages
      route: pathname.includes("/chatbot-settings/")
        ? (isKnowledgeChat ? "chat/chat" : "chat/general_chat")
        : isKnowledgeChat
          ? "chat/chat"
          : pathname.includes("generalchat")
            ? "chat/general_pub_chat"
            : pathname.includes("/chat/")
              ? "chat/pub-chat"
              : "chat/general_chat",
    };
    setCreateChat({ question: "" });
    scrollToBottom();
    dispatch(createGeneralChat(body))
      .unwrap()
      .then((res) => {
        setCreateChat({ question: "" });
        if (res?.data?.success && res?.data?.data) {
          setChatWithBot((prev) => [...prev, res.data.data]);
        } else {
          setChatWithBot((prev) => [
            ...prev,
            res?.data?.message || res?.message || "Sorry, an error occurred. Please wait for some time and try again.",
          ]);
        }
        setLoading(false);
        scrollToBottom();
      })
      .catch((err) => {
        setCreateChat({ question: "" });
        setChatWithBot((prev) => [
          ...prev,
          "Sorry, an error occurred. Please wait for some time and try again.",
        ]);
        setLoading(false);
        scrollToBottom();
      });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setCreateChat({ ...createChat, [name]: value });
  };

  return (
    <div style={{ "--theme-green-text-color": baseColor }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          route !== "chat-history" && !loading && handleCreateChat(e);
        }}
      >
        <div className="enter-message-box">
          <div className="relative">
            {/* Input + Send button wrapper */}
            <div className="input-wrapper">
              <input
                type="text"
                placeholder="Type your message"
                name="question"
                onChange={(e) => handleOnChange(e)}
                value={createChat?.question}
                disabled={route === "chat-history"}
                autoComplete="off"
              />
              {/* Send icon - inside input on right */}
              <div
                className="icon-alignment"
                onClick={(e) => {
                  route !== "chat-history" && !loading && handleCreateChat(e);
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="22" y1="2" x2="11" y2="13" stroke={baseColor} strokeWidth="2"></line>
                  <polygon points="22 2 15 22 11 13 2 9 22 2" fill={baseColor}></polygon>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
